(function () {
  let isAddingToCart = false;
  let lastAddToCartAt = null;

  window.__showcaseCartStatus__ = {
    loading: false,
    success: false,
    data: null,
    updatedAt: null,
  };

  /* =====================================================
     NEW: Visibility state — tracks whether the modal is
     currently in the foreground, keyed to the active
     showcase_id. Updated on every open/close, not just
     at init time.
  ===================================================== */

  window.__showcaseVisibility__ = {
    showcase_id: null,
    isVisible: false,
  };

  function setVisibility(showcase_id, isVisible) {
    window.__showcaseVisibility__ = {
      showcase_id: showcase_id ?? window.__showcaseVisibility__.showcase_id,
      isVisible,
    };

    // Belt-and-suspenders: patch directly onto whatever config
    // object the vendor script actually reads at runtime, in case
    // init() alone doesn't propagate live changes (same pattern
    // used for selectedVariant / payload / context elsewhere).
    if (window.__SHOWCASE_WIDGET_CONFIG__) {
      window.__SHOWCASE_WIDGET_CONFIG__.visibility =
        window.__showcaseVisibility__;
    }

    if (window.ShowcaseWidget) {
      window.ShowcaseWidget.visibility = window.__showcaseVisibility__;
    }

    // Also dispatch a CustomEvent in case the widget listens for
    // visibility changes rather than polling. Data must be nested
    // under `detail` — a top-level key gets silently dropped.
    document.dispatchEvent(
      new CustomEvent("atttic:visibility_change", {
        bubbles: true,
        detail: window.__showcaseVisibility__,
      }),
    );
  }

  async function refreshCartUI() {
    // Patching this theme's cart-drawer Web Components in place
    // (section fetch + declarative Shadow DOM parsing) proved
    // unreliable across several attempts — the drawer kept
    // rendering unstyled/cramped even when the underlying data
    // was correct. A full reload renders the exact same markup
    // the theme's own native add-to-cart flow produces, so it's
    // the reliable option.
    window.location.reload();
  }

  async function addToCart(state) {
    if (!state) return;
    if (isAddingToCart) return;

    isAddingToCart = true;

    window.__showcaseCartStatus__.loading = true;

    const properties = {
      label: state.display_name || "",
    };

    if (state.has_personalisation) {
      if (state.personalisation_text) {
        properties.personalisation_text = state.personalisation_text;
      }

      if (state.personalisation_image) {
        properties.personalisation_image = state.personalisation_image;
      }
    }

    const bundleKey = Date.now().toString();

    const items = [
      {
        id: parseInt(state.shopify_variant_id),
        quantity: 1,
        properties: {
          ...properties,
          _BundleKey: bundleKey,
        },
      },
    ];

    if (
      state.personalisation_text &&
      state.personalisation_text.trim() !== ""
    ) {
      items.push({
        id: 50606382809388,
        quantity: 1,
        properties: {
          _Freebie: "Yes",
          _BundleKey: bundleKey,
          Personalisation: state.personalisation_text,
        },
      });
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        window.__showcaseCartStatus__ = {
          ...window.__showcaseCartStatus__,
          loading: false,
          success: false,
          error: data,
          updatedAt: Date.now(),
        };

        return;
      }

      window.__showcaseATCResponse__ = data;

      window.__showcaseCartStatus__ = {
        ...window.__showcaseCartStatus__,
        loading: false,
        success: true,
        data,
        updatedAt: Date.now(),
      };

      // Pull fresh cart totals + poke the theme's header/drawer
      // BEFORE closing the modal, so the UI is already correct
      // by the time the user sees the storefront again.
      await refreshCartUI();

      closeModal();
    } catch (err) {
      window.__showcaseCartStatus__ = {
        ...window.__showcaseCartStatus__,
        loading: false,
        success: false,
        error: err,
        updatedAt: Date.now(),
      };
    } finally {
      isAddingToCart = false;

      window.__showcaseCartStatus__.loading = false;
    }
  }

  /* =====================================================
     Watch window.__SCROLL_WIDGET_STATE__.cartState instead
     of scraping console.log.
  ===================================================== */

  function evaluateCartState(cs) {
    if (!cs) return;
    if (!cs.add_to_cart) return;

    const timestamp = cs.add_to_cart_at;

    if (timestamp && timestamp === lastAddToCartAt) return;
    if (timestamp) lastAddToCartAt = timestamp;

    addToCart(cs);
  }

  function watchCartStateOn(stateObj) {
    if (!stateObj || stateObj.__atcWatched__) return;
    stateObj.__atcWatched__ = true;

    let _cartState = stateObj.cartState;

    evaluateCartState(_cartState);

    try {
      Object.defineProperty(stateObj, "cartState", {
        configurable: true,
        enumerable: true,
        get() {
          return _cartState;
        },
        set(newVal) {
          _cartState = newVal;
          evaluateCartState(newVal);
        },
      });
    } catch (e) {
      // If defineProperty fails (non-configurable), fall back to polling only
    }
  }

  const attachInterval = setInterval(() => {
    if (window.__SCROLL_WIDGET_STATE__) {
      watchCartStateOn(window.__SCROLL_WIDGET_STATE__);
      clearInterval(attachInterval);
    }
  }, 200);

  setInterval(() => {
    const cs =
      window.__SCROLL_WIDGET_STATE__ &&
      window.__SCROLL_WIDGET_STATE__.cartState;
    evaluateCartState(cs);
  }, 300);

  /* =====================================================
     NEW: Poll-patch visibility onto the vendor config in
     case the widget overwrites window.__SHOWCASE_WIDGET_CONFIG__
     (or window.ShowcaseWidget) after init and drops our key,
     same as the selectedVariant / personalisation cases.
  ===================================================== */

  setInterval(() => {
    if (
      window.__SHOWCASE_WIDGET_CONFIG__ &&
      window.__SHOWCASE_WIDGET_CONFIG__.visibility !==
        window.__showcaseVisibility__
    ) {
      window.__SHOWCASE_WIDGET_CONFIG__.visibility =
        window.__showcaseVisibility__;
    }
  }, 300);

  let widgetInitialized = false;

  const modal = document.getElementById("showcase-modal");

  const modalInner = document.getElementById("modal-inner");

  const offscreen = document.getElementById("widget-offscreen");

  const widgetEl = document.getElementById("my-widget");

  async function fetchCollectionProducts() {
    const path = window.location.pathname;

    if (!path.includes("/collections/")) return;

    const handle = path.split("/collections/")[1].split("/")[0].split("?")[0];

    if (!handle) return;

    const showcase_id =
      (window.__collectionShowcaseMap__ || {})[handle] || null;

    let page = 1;

    let allProducts = [];

    while (true) {
      const res = await fetch(
        `/collections/${handle}/products.json?limit=250&page=${page}`,
      );

      const data = await res.json();

      if (!data.products || data.products.length === 0) break;

      allProducts = allProducts.concat(data.products);

      if (data.products.length < 250) break;

      page++;
    }

    window.currentCollectionData = {
      handle,
      showcase_id,
      products: allProducts,
    };

    widgetInitialized = false;

    initWidget();
  }

  function initWidget() {
    if (widgetInitialized) return;

    if (!window.currentCollectionData) return;

    setVisibility(window.currentCollectionData.showcase_id, false);

    window.ShowcaseWidget.init({
      target: "#my-widget",
      showcase_id: window.currentCollectionData.showcase_id,
      shop: window.__showcaseShop__,
      productInfo: window.currentCollectionData,
      inW: offscreen.offsetWidth,
      inH: offscreen.offsetHeight,
      cartStatus: window.__showcaseCartStatus__,
      atcResponse: window.__showcaseATCResponse__,
      visibility: window.__showcaseVisibility__,
    });

    widgetInitialized = true;
  }

  function openModal() {
    widgetEl.style.position = "absolute";

    widgetEl.style.inset = "0";

    widgetEl.style.width = "100%";

    widgetEl.style.height = "100%";

    modalInner.appendChild(widgetEl);

    modal.classList.add("active");

    modal.style.display = "flex";

    modal.style.visibility = "visible";

    modal.style.opacity = "1";

    modal.style.pointerEvents = "auto";

    document.body.style.overflow = "hidden";

    document.querySelector("header").style.display = "none";

    setVisibility(
      window.currentCollectionData && window.currentCollectionData.showcase_id,
      true,
    );
  }

  function closeModal() {
    widgetEl.style.position = "";
    widgetEl.style.inset = "";

    offscreen.appendChild(widgetEl);

    void offscreen.offsetHeight;

    modal.classList.remove("active");
    modal.style.display = "none";
    modal.style.visibility = "hidden";
    modal.style.opacity = "0";
    modal.style.pointerEvents = "none";

    document.body.style.overflow = "";

    document.querySelector("header").style.display = "";

    setVisibility(
      window.currentCollectionData && window.currentCollectionData.showcase_id,
      false,
    );
  }

  document
    .getElementById("open-showcase-btn")
    .addEventListener("click", openModal);

 document.getElementById("to_open_3d_modal").addEventListener("click", openModal);  	

  document
    .getElementById("close-showcase-btn")
    .addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  fetchCollectionProducts();

  const _pushState = history.pushState.bind(history);

  history.pushState = function (...args) {
    _pushState(...args);

    fetchCollectionProducts();
  };

  window.addEventListener("popstate", fetchCollectionProducts);
})();
